<template>
  <div style="display: inline;">
    <p style="font-size: 15px; margin-left: 6px; margin-bottom: 8px; font-weight: bold;">{{ $t('suanfazuhexinxi') }}</p>
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" :getUrl="pageUrl" getKey="rows" :columns="columns" v-loading="loading">
      <template #shifouqiyong="scope">
        {{ scope.row.enableFlag === 0 ? $t('fou') : $t('shi') }}
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_scheduling_algorithm_settings_update')" type="text" @click="yt.showEditDialog('bianji', scope.row, 'w1')">{{ $t('bianji') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('algorithmFactor') + ':'" required>
            {{ yt.editObj.algorithmFactor }}
          </el-form-item>
          <br />
          <el-form-item :label="$t('miaoshu') + ':'" required>
            {{ yt.editObj.describe }}
          </el-form-item>
          <br />
          <el-form-item :label="$t('weights-from') + ':'" required>
            <el-input-number v-model="yt.editObj.weights" :controls="false" :max="10" :min="1" />
            <br />
            <span style="font-size: 10px;color: red">{{ $t('qingshuru1-10,10daibiaoquanzhongzuigao') }}</span>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong') + ':'" required>
            <el-select v-model="yt.editObj.enableFlag">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/algorithm/combination/item/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'web_scheduling_algorithm_combination_item',
  data() {
    return {
      pageUrl: '/web/algorithm/combination/item/page?algorithmCombinationId=' + this.$attrs.combination.id,
      loading: false,
      columns: [
        {
          label: 'algorithmFactor',
          prop: 'algorithmFactor'
        },
        {
          label: 'miaoshu',
          prop: 'describe'
        },
        {
          label: 'weights',
          prop: 'weights'
        },
        {
          label: 'shifouqiyong',
          prop: 'enableFlag',
          type: 'slot'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ],
      formRules: {
        weights: [{ required: true }]
      }
    };
  },
  methods: {},
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  }
};
</script>

<style scoped lang="scss"></style>
